// extracted by mini-css-extract-plugin
export default {"container":"tP-z","title":"uP-z","link":"vP-z"};